export const RESET_STATE = "RESET_STATE";
export const SET_CONTENT = "SET_CONTENT";
export const SET_SEARCH = "SET_SEARCH";
